import { createContext, useContext } from 'react';

const CategoryContext = createContext({ wineType: '1' });

export const CategoryProvider = CategoryContext.Provider;

export const useCategory = () => useContext(CategoryContext);

export default CategoryContext;
